export default "__VITE_ASSET__BlkWgTk2__"